import React from "react";
import { Link } from "react-router-dom";

const CEO = () => {
  return (
    <>
      <section
        className="banner__inner-page bg-image pt-180 pb-180 bg-image"
        style={{
          background: "url(/assets/images/banner/banner-inner-page.jpg)",
        }}
      >
        <div
          className="shape2 wow slideInLeft"
          data-wow-delay="00ms"
          data-wow-duration="1500ms"
        >
          <img src="/assets/images/banner/inner-banner-shape2.png" alt="shape" />
        </div>
        <div
          className="shape1 wow slideInLeft"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <img src="/assets/images/banner/inner-banner-shape1.png" alt="shape" />
        </div>
        <div
          className="shape3 wow slideInRight"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <img
            className="sway__animationX"
            src="/assets/images/banner/inner-banner-shape3.png"
            alt="shape"
          />
        </div>
        <div className="container">
          <h2
            className="wow fadeInUp"
            data-wow-delay="00ms"
            data-wow-duration="1500ms"
          >
            Chief Executive Officer
          </h2>
          <div
            className="breadcrumb-list wow fadeInUp"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <Link to="/">Home</Link>
            <span>
              <i className="fa-regular fa-angles-right mx-2" />
              Chief Executive Officer
            </span>
          </div>
        </div>
      </section>

      <section className="team-single pt-120 pb-120">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-4 col-md-6">
              <div className="team-single__image">
                <img src="/assets/images/team/team-image1.jpg" alt="image" />
                <div className="team-info">
                  <a to="/">
                    <i className="fa-brands fa-facebook-f" />
                  </a>
                  <a to="/" className="active">
                    <i className="fa-brands fa-instagram" />
                  </a>
                  <a to="/">
                    <i className="fa-brands fa-linkedin-in" />
                  </a>
                  <a to="/">
                    <i className="fa-brands fa-pinterest-p" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="team-single__content">
                <div className="title pb-20 mb-20 bor-bottom">
                  <h3>V S N Raju</h3>
                  <span className="primary-color mt-1">
                    Managing Director & CEO
                  </span>
                </div>
                <div className="team-single__info">
                  <p className="mb-20">
                    V S N Raju is an electronics and communication engineer from
                    the University of Madras and holds an extensive experience
                    of about two decades in sales, marketing and operations.
                    Today he is the Managing Director & CEO of COEMPT
                    EDUTECK PRIVATE LIMITED, which is one of the leading
                    teaching, learning and examination solution providers in
                    India.
                  </p>
                  <p>
                    Before Raju joined COEMPT EDUTECK PRIVATE LIMITED, he was a
                    successful business partner of National Institute of Sales
                    (NIS), a division of NIIT. During this tenure, he was
                    associated with many promising initiatives which involved
                    both students and corporate enterprises. He also worked with
                    Andhra Electronics Limited, leading different marketing
                    initiatives specifically in the government and the export
                    space.
                  </p>
                </div>
              </div>
            </div>
            <p>
              Apart from being a member of several panels and boards of
              educational institutions and developmental forums, Raju is a
              trustee of the prestigious 'Centre for Entrepreneurship
              Development, Tamil Nadu' (CED-TN) which is recognized by the
              Ministry of Small Scale Industry, Government of India and
              Industries Department, Government of Tamil Nadu.
            </p>
            <p>
              Raju believes that technology interventions are essential to
              empower the teachers and students in their regular
              teaching-learning endeavors, and in this pursuit he has
              successfully collaborated with several universities, educational
              institutions and government educational departments to deliver
              turnkey ICT solutions. COEMPT EDUTECK PRIVATE LIMITED, under
              Raju's supervision has also joined hands with NASSCOM to assess
              entry level talent for the IT-BPM companies.
            </p>
            <p>
              For the various progressive initiatives undertaken under his
              leadership in the education enablement space Raju was bestowed the
              title of 'Emerging Leader' at 'The World's Greatest Brands &
              Leaders Asia & GCC' summit.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default CEO;
